import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from '../../data/ui';

const SELECTED_STEP_SIZE = 32;

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      padding: '0px !important',
      background: 'none',

      '&$horizontal': {
        '&[data-steps="2"]': {
          width: '132px',
        },
        '&[data-steps="3"]': {
          width: '234px',
        },
        '&[data-steps="4"]': {
          width: '337px',
        },

        '&$displayText': {
          '&[data-steps="2"]': {
            minWidth: '200px',
          },
          '&[data-steps="3"]': {
            minWidth: '300px',
          },
          '&[data-steps="4"]': {
            minWidth: '400px',
          },

          '& $stepIcon_root': {
            transform: 'scale(1)',
            '& circle': {
              background: COLORS.primary.light,
            },
          },
          '& $stepIcon_active': {},
          '& $connector': {
            margin: '0 -4px',
            top: SELECTED_STEP_SIZE + 'px !important',
          },
        },
      },

      '&$vertical': {
        '& $connector': {
          margin: '-6px 0 -6px 15px',
          padding: 0,
        },
        '& $connector_line': {
          borderTopWidth: 0,
          borderBottomWidth: 0,
          minHeight: 48,
        },
        '& $stepLabel_labelContainer': {
          marginLeft: theme.spacing(1),
        },
      },
    },
    displayText: {},
    horizontal: {},
    vertical: {},

    connector: {},
    connector_line: {
      borderColor: COLORS.primary.light,
      borderTopWidth: 1,
      borderBottomWidth: 1,
      borderRadius: 1,
    },
    step_root: {
      padding: '0',
    },
    stepLabel: {},
    stepLabel_active: {},
    stepLabel_completed: {
      color: COLORS.gray.gray50 + ' !important',
    },
    stepLabel_labelContainer: {
      marginTop: theme.spacing(-0.5),
    },
    stepLabel_iconContainer: {
      padding: '0',
    },
    stepLabel_label: {
      letterSpacing: 'normal',
    },
    stepLabel_alternativeLabel: {
      marginTop: theme.spacing(1) + 'px !important',
      marginBottom: theme.spacing(0.5) + 'px !important',
      fontSize: theme.typography.pxToRem(14) + ' !important',
    },
    stepIcon_root: {
      fontSize: theme.typography.pxToRem(SELECTED_STEP_SIZE),
      transform: 'scale(0.625)',
    },
    stepIcon_active: {
      transform: 'scale(1)',
    },
    stepIcon_large: {
      transform: 'scale(1.125)',
    },
  }),
  { name: 'WizardStepper' }
);
